import { getInitials } from '@agentguru/helpers';
import { useMe } from './useMe';
export function useUserInitials() {
    var text = '';
    var data = useMe().data;
    if (data) {
        var _a = data.getUser, first_name = _a.first_name, last_name = _a.last_name;
        text = "".concat(first_name, " ").concat(last_name);
    }
    return getInitials(text);
}
